import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "../question-base";

export class TextboxQuestion extends QuestionBase<string> {
  override type = InputType.TEXT
}